export enum WarehouseType {
    ExternalWarehouseFBS = 'external_fbs',
    ExternalWarehouseFBO = 'external_fbo',
    FBS = 'fbs',
    PublicFBS = 'public_fbs',
    Supplier = 'supplier',
}